import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardHeader, CardMedia, CardActions, Button, Tooltip } from '@material-ui/core';
import { Map as MapIcon, Code as CodeIcon } from '@material-ui/icons';


const useStyles = makeStyles({
    card: {
        minWidth: 200,
    },
    media: {
        height: 0,
        //verticalAlign: 'middle',
        paddingTop: '60%', // 16:9
    },
    button: {
        minWidth: 30
    }
});

export default function SimpleCard(props) {
    const classes = useStyles();

    const [tile, setTile] = useState(true)

    const onMouseEnterHandler = () => {
        console.log('enter')
        setTile(false)
    }

    const onMouseLeaveHandler = () => {
        console.log('leave')
        setTile(true)
    }

    return (
        <Card square elevation={1} className={classes.card}>
            <CardHeader
                subheader={props.title}
            />
            <a href={props.map} target="_blank" rel="noopener noreferrer">
                <CardMedia
                    className={classes.media}
                    image={`https://th.frb-data.dk/${props.title}/12/2190/1281.png`}
                    title={props.title}
                    onMouseEnter={onMouseEnterHandler}
                    onMouseLeave={onMouseLeaveHandler}
                />
            </a>
            <CardActions>
                <Tooltip title='Se meta.json' placement='top'>
                    <a href={props.meta} target="_blank" rel="noopener noreferrer">
                        <Button size="small" className={classes.button} ><CodeIcon /></Button>
                    </a>
                </Tooltip>
            </CardActions>
        </Card>
    );
}
